export default {
  'accessLog.title': 'Manage Access Logs',
  'accessLog.operationType.login': 'Login',
  'accessLog.operationType.logout': 'Logout',
  'accessLog.operationType.refreshCredentials': 'Refresh credentials',
  'accessLog.form.operationType': 'Operation Type',
  'accessLog.accessType.mixed': 'Mixed',
  'accessLog.accessType.userAndPassword': 'Username and Password',
  'accessLog.accessType.office365': 'Office365',
  'accessLog.accessType.google': 'Google',
  'accessLog.accessType.automy': 'AUTOMY',
  'accessLog.text.accessType': 'Access Type',
  'accessLog.text.isSuccessfulOperation': 'Successful Operation?',
  'accessLog.text.ip': 'IP',
  'accessLog.text.appClient': 'Client',
  'accessLog.text.observations': 'Observations',
  'accessLog.text.country': 'Country',
  'accessLog.text.city': 'City',
  'accessLog.text.state': 'State',
  'accessLog.text.userAgent': 'User Agent',
  'accessLog.text.app': 'App',
  'accessLog.text.portal': 'Portal',
  'accessLog.text.accessPolicyId': 'Access policy ID',
  'accessLog.text.accessPolicyName': 'Access policy name',
  'accessLog.text.accessPolicyEffect': 'Access policy effect',
  'accessLog.text.accessPolicyDecision': 'Access policy decision',
  'accessLog.accessPolicyDecision.noMatch': 'No match',
  'accessLog.accessPolicyDecision.matchedDeny': 'Matched — deny',
  'accessLog.accessPolicyDecision.matchedAllow': 'Matched — allow',
  'accessLog.text.accessPolicyMatchedPath': 'Access policy matched path',
  'accessLog.text.accessPolicyEvaluation': 'Access policy evaluation',
};
